<section>
  <div class="cart-page">

    <!-- ── Empty State ──────────────────────────────────────────────────────── -->
    <div *ngIf="showMessage" class="empty-cart">
      <img src="../../../assets/images/cart.png" class="empty-cart-img" alt="Empty cart" />
      <h2 class="empty-cart-title">{{ 'cart.empty' | translate }}</h2>
      <a routerLink="/shop" class="btn-shop-now">{{ 'cart.discover' | translate }}</a>
    </div>

    <!-- ── Cart Content ──────────────────────────────────────────────────────── -->
    <ng-container *ngIf="!showMessage">

      <!-- ── Step 1: Review ────────────────────────────────────────────────── -->
      <div class="cart-review-block">
        <div class="cart-title-row">
          <h1 class="cart-title">{{ 'cart.title' | translate }}</h1>
          <span class="remove-all-link" (click)="removeAll()">{{ 'cart.remove_all' | translate }}</span>
        </div>

        <!-- Out-of-stock notice -->
        <div class="cart-notice" *ngIf="zeroQuantity">
          <i class="ti-info-alt"></i>
          {{ 'cart.notice' | translate }}
        </div>

        <!-- Products in cart -->
        <ng-container *ngFor="let item of cart">
          <div class="cart-item" *ngIf="item?.count">
            <img class="cart-item-img" [src]="item?.imagePath" [alt]="item?.name" />
            <div>
              <p class="cart-item-name">{{ item?.name | truncate: 50 }}</p>
            </div>
            <p class="cart-item-price">{{ item?.price }} LE</p>
            <p class="cart-item-qty">× {{ item?.count }}</p>
            <p class="cart-item-total">{{ item?.count * item?.price }} LE</p>
            <button class="cart-remove-btn" (click)="removeItem(item?.id)" [title]="'cart.remove' | translate">
              <i class="ti-trash"></i>
            </button>
          </div>
        </ng-container>

        <hr class="cart-section-divider" />

        <!-- Packages in cart -->
        <ng-container *ngFor="let item of cart">
          <div class="cart-item" *ngIf="!item?.count">
            <img class="cart-item-img" [src]="apiUrl + item?.image" [alt]="item?.name" />
            <div>
              <p class="cart-item-name">{{ item?.name | truncate: 50 }}</p>
              <p class="cart-item-meta">{{ 'cart.package_label' | translate }}</p>
            </div>
            <p class="cart-item-price">{{ item?.total_price }} LE</p>
            <p class="cart-item-qty">× {{ item?.amount }}</p>
            <p class="cart-item-total">{{ item?.amount * item?.total_price }} LE</p>
            <button class="cart-remove-btn" (click)="removeItem(item?.id)" [title]="'cart.remove' | translate">
              <i class="ti-trash"></i>
            </button>
          </div>
        </ng-container>
      </div>

      <!-- ── Step 2: Checkout ──────────────────────────────────────────────── -->
      <h2 class="checkout-block-title">{{ 'cart.checkout' | translate }}</h2>

      <div class="cart-summary-panel">
        <p class="summary-title">{{ 'cart.summary' | translate }}</p>

        <!-- Region / Delivery fees -->
        <div class="cart-form-section">
          <p class="section-label">{{ 'cart.delivery_region' | translate }}</p>
          <div class="options">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'cart.select_region' | translate }}</mat-label>
                <mat-select required (selectionChange)="changeAria($event)">
                  <mat-option *ngFor="let region of deliveryRegions" [value]="region.price">
                    <div class="custom-mat-option">
                      <span>{{ region.name }}</span>
                      <span>{{ region.price }} LE</span>
                    </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Phone number -->
        <div class="cart-form-section" [formGroup]="phoneNoForm">
          <p class="section-label">{{ 'cart.contact_phone' | translate }}</p>
          <input
            formControlName="phoneNumber"
            type="tel"
            class="lux-input"
            placeholder="01XXXXXXXXX"
            appPreventSpaceDirective
            [(ngModel)]="userInput"
            (keypress)="validateInput($event)"
          />
          <span class="field-error" *ngIf="phoneNoForm?.controls.phoneNumber.touched && phoneNoForm?.controls.phoneNumber.errors?.['required']">
            {{ 'cart.phone_required' | translate }}
          </span>
          <span class="field-error" *ngIf="phoneNoForm.controls.phoneNumber.errors?.['invalidEmailOrPhone']">
            {{ 'cart.phone_invalid' | translate }}
          </span>
        </div>

        <!-- Address section -->
        <div class="cart-form-section">
          <p class="section-label">
            {{ (userAddresses?.length ? 'cart.delivery_address' : 'cart.add_address') | translate }}
          </p>

          <!-- Address list -->
          <div class="address-list" *ngIf="!showAddingNewAddressForm">
            <div
              *ngFor="let address of userAddresses"
              class="address-card"
              [class.selected]="addressIdSelected === address.id"
            >
              <input
                type="radio"
                [id]="'addr_' + address.id"
                [value]="address?.id"
                name="address"
                (change)="selectAddress(address?.id)"
              />
              <div>
                <p class="address-city">{{ address?.city }} <small>{{ address?.governorate }}</small></p>
                <p class="address-detail">{{ address?.addresss }}</p>
              </div>
            </div>
          </div>

          <!-- Add new address form -->
          <form [formGroup]="clientAddress" *ngIf="showAddingNewAddressForm" class="address-form-grid">
            <div class="form-field-lux">
              <label for="city">{{ 'cart.city' | translate }}</label>
              <input id="city" formControlName="city" type="text" class="lux-input" [placeholder]="'cart.city' | translate" />
            </div>
            <div class="form-field-lux">
              <label for="gov">{{ 'cart.governorate' | translate }}</label>
              <input id="gov" formControlName="governorate" type="text" class="lux-input" [placeholder]="'cart.governorate' | translate" />
            </div>
            <div class="form-field-lux full-width">
              <label for="addr">{{ 'cart.street' | translate }}</label>
              <input id="addr" formControlName="address" type="text" class="lux-input" [placeholder]="'cart.street_placeholder' | translate" />
            </div>
          </form>

          <div class="address-actions">
            <button
              *ngIf="!showAddingNewAddressForm"
              (click)="addNewAddress()"
              class="btn-address"
            >
              {{ 'cart.add_new' | translate }}
            </button>
            <button
              *ngIf="showAddingNewAddressForm"
              (click)="saveAddress()"
              class="btn-address primary"
              [disabled]="!clientAddress.valid"
            >
              {{ 'cart.save_address' | translate }}
            </button>
            <button
              *ngIf="showAddingNewAddressForm"
              (click)="backToAddressesList()"
              class="btn-address"
            >
              {{ 'cart.back' | translate }}
            </button>
          </div>
        </div>

        <!-- Promo code -->
        <div class="cart-form-section">
          <p class="section-label">{{ 'cart.promo' | translate }}</p>
          <div class="promo-row">
            <input
              [(ngModel)]="promoName"
              (input)="changeData($event)"
              (keyup.enter)="getValue($event)"
              type="text"
              class="lux-input"
              [placeholder]="'cart.promo_placeholder' | translate"
            />
            <button
              [disabled]="disabledButton"
              (click)="getValue($event)"
              class="btn-promo"
            >
              {{ 'cart.promo_apply' | translate }}
            </button>
          </div>
          <span *ngIf="showPromo" class="promo-valid">{{ 'cart.promo_saved' | translate }} {{ discountValue }} LE</span>
          <span *ngIf="showNotValidPromo" class="promo-invalid">{{ 'cart.promo_invalid' | translate }}</span>
        </div>

        <!-- Payment method -->
        <div class="cart-form-section">
          <p class="section-label">{{ 'cart.payment' | translate }}</p>
          <div class="payment-options">
            <div class="payment-option">
              <input type="radio" id="cashOnDelivery" name="payment_method" value="cashOnDelivery" (change)="paymentMethodValue(true)" />
              <label for="cashOnDelivery">{{ 'cart.cod' | translate }}</label>
            </div>
            <div class="payment-option">
              <input type="radio" id="vodafoneCash" name="payment_method" value="vodafoneCash" (change)="paymentMethodValue(false)" />
              <label for="vodafoneCash">{{ 'cart.vodafone' | translate }}</label>
            </div>
          </div>
        </div>

        <!-- Totals -->
        <div class="summary-row mt-3">
          <span class="summary-label">{{ 'cart.subtotal' | translate }}</span>
          <span class="summary-value">{{ oldTotalPrice }} LE</span>
        </div>
        <div class="summary-row" *ngIf="showFees">
          <span class="summary-label">{{ 'cart.delivery_fees' | translate }}</span>
          <span class="summary-value">{{ fees }} LE</span>
        </div>
        <div class="summary-row" *ngIf="!showFees">
          <span class="summary-label">{{ 'cart.delivery_fees' | translate }}</span>
          <span class="summary-note">{{ 'cart.select_above' | translate }}</span>
        </div>

        <div class="summary-total">
          <span class="total-label">{{ 'cart.total' | translate }}</span>
          <span class="total-amount">{{ totalPrice }} LE</span>
        </div>

        <div class="confirm-missing-list" *ngIf="fees === '' || !paymentMethodSelected || phoneNoForm?.invalid || !addressSelected">
          <span class="missing-item" *ngIf="fees === ''">{{ 'cart.missing_region' | translate }}</span>
          <span class="missing-item" *ngIf="phoneNoForm?.invalid">{{ 'cart.missing_phone' | translate }}</span>
          <span class="missing-item" *ngIf="!addressSelected">{{ 'cart.missing_address' | translate }}</span>
          <span class="missing-item" *ngIf="!paymentMethodSelected">{{ 'cart.missing_payment' | translate }}</span>
        </div>

        <button
          class="btn-confirm"
          (click)="checkout()"
          [disabled]="fees === '' || !paymentMethodSelected || phoneNoForm?.invalid || !addressSelected"
        >
          {{ 'cart.confirm' | translate }}
        </button>
      </div>

    </ng-container>
  </div>
</section>
